module.exports = __webpack_public_path__ + "static/media/FB3@2x.36c74b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/FB/FB3@2x.png
// module id = 637
// module chunks = 0